import React from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "hr", name: "Hrvatski" },
  { code: "en", name: "English" },
  { code: "de", name: "Deutsch" },
];

export const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  return (
    <div role="group" aria-label={t("common.language")} data-testid="language-switcher" className="flex shrink-0 items-center gap-0.5">
      {languages.map(({ code, name }) => (
        <button key={code} type="button" lang={code} title={name} aria-label={name}
          data-testid={`language-${code}`} aria-pressed={i18n.resolvedLanguage === code}
          onClick={() => i18n.changeLanguage(code)}
          className={`h-8 w-8 rounded-full text-[10px] font-semibold transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0057FF] ${i18n.resolvedLanguage === code ? "bg-[#0057FF] text-white" : "text-[#0e0e10]/65 hover:bg-black/5 hover:text-[#0057FF]"}`}>
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};